import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Snackbar,
  Alert,
  Divider,
  Drawer,
  IconButton,
  CircularProgress,
} from "@mui/material";
import {
  // PermContactCalendar as PeopleIcon,
  // LocalOffer as LabelIcon,
  // CellTower as CampaignIcon,
  // SettingsSuggest as AutomationIcon,
  // AccountTree as FlowIcon,
  // Inbox as Chat,
  Person as PersonIcon,
  // GroupAddOutlined,
} from "@mui/icons-material";
import { useTheme, useMediaQuery } from "@mui/material";
import MyAccountService from "../services/MyAccountService";
// import { getShortStoreName } from "../utils/extentions";
import FormField from "./FormField";
import { FeedSubscribedIcon, Heading, MenuIcon, Text } from "evergreen-ui";
import { IntegrationDialog } from "./Dialog";
import ServicesService from "../services/ServicesService";
import WhatsApp from "../models/WhatsappModel";
import { errorMessage } from "../shared/utils/validators";
import axios from "axios";
import API_CONFIG from "../config/api.config";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TeamInbox from "../shared/icons/team_inbox.svg";
import TeamInbox1 from "../shared/icons/team_inbox1.svg";
import Contact from "../shared/icons/contact1.svg";
import Contact1 from "../shared/icons/contact.svg";
import Broadcast from "../shared/icons/broadcast1.svg";
import Broadcast1 from "../shared/icons/broadcast.svg";
import Tag from "../shared/icons/tag1.svg";
import Tag1 from "../shared/icons/tag.svg";
import Automation from "../shared/icons/automation1.svg";
import Automation1 from "../shared/icons/automation.svg";
import Logo from "../assets/logo.png";

const TopNavigation = ({
  // onMenuClick,
  // title,
  activeTab = "contacts",
  onTabChange,
}) => {
  const [appId, setAppId] = useState(null);
  const [configId, setConfigId] = useState(null);
  const [pinValue, setPinValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isCatalogOpen, setIsCatalogOpen] = useState(false);
  const [isFbReady, setIsFbReady] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [catalogId, setCatalogId] = useState("");
  const [accessToken, setAccessToken] = useState(null);
  const pendingSignupRef = useRef(null);
  const [whatsapp, setWhatsapp] = useState({
    phoneNumberId: "",
    wabaId: "",
    accessToken: "",
    isEmbeddedSignup: 0,
    businessNumber: "",
    isHistory: "not-started",
    isContact: "not-started",
    chunkData: {},
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const [showCopyDialog, setShowCopyDialog] = useState(false);
  const [copiedPhone, setCopiedPhone] = useState(false);
  const [copiedWaba, setCopiedWaba] = useState(false);
  const [copyDialogData, setCopyDialogData] = useState({
    phone_number_id: "",
    waba_id: "",
  });
  const [syncDialogOpen, setSyncDialogOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  function toggleDrawer() {
    setMobileOpen((prev) => !prev);
  }

  // const [whatsappId, setWhatsappId] = useState(null);
  const tabs = [
    {
      id: "teamchat",
      label: "Team Inbox",
      activeIcon: TeamInbox,
      inactiveIcon: TeamInbox1,
    },
    {
      id: "contacts",
      label: "Contacts",
      activeIcon: Contact,
      inactiveIcon: Contact1,
    },
    // {
    //   id: "group",
    //   label: "Groups",
    //   icon: <GroupAddOutlined fontSize="small" />,
    // },
    {
      id: "tags",
      label: "Tags",
      activeIcon: Tag,
      inactiveIcon: Tag1,
    },
    {
      id: "broadcast",
      label: "Broadcast",
      activeIcon: Automation,
      inactiveIcon: Broadcast1,
    },
    {
      id: "automation",
      label: "Automation",
      activeIcon: Automation,
      inactiveIcon: Automation1,
    },
    // {
    //   id: "flow",
    //   label: "Flow",
    //   icon: <FlowIcon fontSize="small" />,
    // },
    {
      id: "plan",
      label: "Plans",
      icon: <FeedSubscribedIcon fontSize="small" />,
    },
  ];
  const [accName, setAccName] = useState("WG");
  const [step, setStep] = useState(1);

  function renderForm() {
    return (
      <div
        style={{
          maxWidth: 500,
          margin: "0 auto",
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          fontFamily: "Inter, sans-serif",
        }}
      >
        {/* HEADER */}
        <Heading size={600} style={{ marginBottom: 20, textAlign: "center" }}>
          Connect WhatsApp to OrkaStores
        </Heading>

        {/* PROGRESS INDICATOR */}
        <Text
          size={200}
          style={{ color: "#6b7280", textAlign: "center", marginBottom: 20 }}
        >
          Step {step} of 3
        </Text>

        {/* STEP CONTENT */}
        {step === 1 && (
          <div style={{ lineHeight: 1.6 }}>
            <Text style={{ marginBottom: 15 }}>
              You’ll be redirected to Meta to securely connect your WhatsApp
              Business number.
            </Text>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                marginBottom: 30,
              }}
            >
              <Text>• Log in with Facebook / Meta Business</Text>
              <Text>• Accept WhatsApp & Meta terms</Text>
              <Text>• Select or create a business</Text>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={() => setStep(2)}>Next</Button>
            </div>
          </div>
        )}

        {step === 2 && (
          <div style={{ lineHeight: 1.6 }}>
            <Text style={{ marginBottom: 15 }}>
              If you use an existing WhatsApp Business App number:
            </Text>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                marginBottom: 30,
              }}
            >
              <Text>• Old chats stay on your phone</Text>
              <Text>• Old chats won’t appear in OrkaStores</Text>
              <Text>• Replies from the phone app won’t sync</Text>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button variant="secondary" onClick={() => setStep(1)}>
                Back
              </Button>
              <Button onClick={() => setStep(3)}>Continue</Button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div style={{ lineHeight: 1.6 }}>
            <Text style={{ fontWeight: 600, marginBottom: 15 }}>
              Before continuing
            </Text>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                marginBottom: 15,
              }}
            >
              <Text>• Complete WhatsApp setup in Meta</Text>
              <Text>
                • <strong>Add a payment method</strong> to enable message
                sending immediately
              </Text>
            </div>

            <Text size={200} style={{ color: "#6b7280", marginBottom: 20 }}>
              Billing is required by Meta. Messaging may remain disabled until a
              payment method is added.
            </Text>
            <br />
            <Text style={{ marginBottom: 20 }}>
              Click below to continue with Facebook and complete WhatsApp setup.
            </Text>

            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                label="Continue with Facebook"
                disabled={!isFbReady}
                onClick={() => {
                  launchWhatsAppSignup();
                }}
              >
                Facebook Login
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
  function renderSyncDialog() {
    const isContactSync = whatsapp.isContact;
    const isHistorySync = whatsapp.isHistory;
    const progress = whatsapp.chunkData?.progress || 0;

    return (
      <Dialog
        open={syncDialogOpen}
        onClose={() => setSyncDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: 18 }}>
          Sync WhatsApp Data
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ mb: 2 }}>
            <Box sx={{ mt: 1, ml: 1 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ lineHeight: 1.7 }}
              >
                • Media messages older than 14 days will not be synced.
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ lineHeight: 1.7 }}
              >
                • Only Image, Audio and Document messages will be synced.
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ lineHeight: 1.7, mt: 1 }}
              >
                • If sync fails or is incomplete, disconnect your business from
                the WhatsApp Business app, re-login using embedded signup, and
                try again.
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ lineHeight: 1.7, mt: 1 }}
              >
                • To sync chat history, ensure you allow sync while connecting
                your WhatsApp Business app.
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "grid",
              gap: 2,
              gridTemplateColumns: "1fr 1fr",
              mb: 2,
            }}
          >
            <Button
              variant={isContactSync === "completed" ? "contained" : "outlined"}
              color={isContactSync === "completed" ? "success" : "primary"}
              disabled={
                isContactSync === "completed" || isContactSync === "in-progress"
              }
              onClick={() => handleSyncHistory("contacts")}
              fullWidth
              sx={{ height: 48, textTransform: "none" }}
            >
              {isContactSync === "completed"
                ? "Contacts Synced"
                : isContactSync === "in-progress"
                  ? "Syncing Contacts..."
                  : "Sync Contacts"}
            </Button>

            <Button
              variant={isHistorySync === "completed" ? "contained" : "outlined"}
              color={isHistorySync === "completed" ? "success" : "primary"}
              disabled={
                isContactSync !== "completed" ||
                isHistorySync === "completed" ||
                isHistorySync === "in-progress"
              }
              onClick={() => handleSyncHistory("history")}
              fullWidth
              sx={{ height: 48, textTransform: "none" }}
            >
              {isHistorySync === "completed"
                ? "History Synced"
                : isHistorySync === "in-progress"
                  ? "Syncing History..."
                  : "Sync History"}
            </Button>
          </Box>

          {isHistorySync === "in-progress" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1.5,
                mt: 1,
                py: 2,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                backgroundColor: "background.paper",
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                Syncing history
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Progress: {Math.round(progress)}%
              </Typography>

              <Box sx={{ position: "relative", display: "inline-flex" }}>
                <CircularProgress
                  variant="determinate"
                  value={progress}
                  size={60}
                />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="caption"
                    component="div"
                    color="text.secondary"
                  >
                    {`${Math.round(progress)}%`}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setSyncDialogOpen(false)}
            sx={{ textTransform: "none" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function renderCopyDialog() {
    return (
      <Dialog open={showCopyDialog} onClose={() => {}} maxWidth="xs" fullWidth>
        <DialogTitle>Copy Your WhatsApp Details</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            <b>Important:</b> You will <b>not</b> be able to view these values
            later. Please copy them now for your reference.
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <TextField
              label="Phone Number ID"
              value={copyDialogData.phone_number_id}
              InputProps={{ readOnly: true }}
              fullWidth
              sx={{ mr: 1 }}
            />
            <Button
              variant={copiedPhone ? "contained" : "outlined"}
              color={copiedPhone ? "success" : "primary"}
              onClick={() => {
                navigator.clipboard.writeText(copyDialogData.phone_number_id);
                setCopiedPhone(true);
              }}
            >
              {copiedPhone ? "Copied" : "Copy"}
            </Button>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <TextField
              label="WABA ID"
              value={copyDialogData.waba_id}
              InputProps={{ readOnly: true }}
              fullWidth
              sx={{ mr: 1 }}
            />
            <Button
              variant={copiedWaba ? "contained" : "outlined"}
              color={copiedWaba ? "success" : "primary"}
              onClick={() => {
                navigator.clipboard.writeText(copyDialogData.waba_id);
                setCopiedWaba(true);
              }}
            >
              {copiedWaba ? "Copied" : "Copy"}
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            disabled={!(copiedPhone && copiedWaba)}
            onClick={() => setShowCopyDialog(false)}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  async function createCatalog() {
    try {
      await ServicesService.creatCatalog(catalogId);
      setSnackbar({
        open: true,
        message: "Catalog Connected successfully!",
        severity: "success",
      });
      setIsCatalogOpen(false);
    } catch (error) {
      console.log("error", error);
      setSnackbar({
        open: true,
        message: "Catalog Not Connected",
        severity: "error",
      });
      setIsCatalogOpen(false);
    }
  }
  function renderCatalogForm() {
    return (
      <div style={{ paddingTop: 10, paddingBottom: 10 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: 10,
          }}
        >
          <Heading size={500}>Connect Your Catalog</Heading>
        </div>
        <Text style={{ paddingTop: 15 }}>
          Please make sure your catalog connected to your whatsapp business
          number
        </Text>
        <FormField
          type="text"
          label="Catalog id"
          isRequired
          name="catalogId"
          value={catalogId}
          onChange={(e) => {
            setCatalogId(e.target.value);
          }}
          error={
            catalogId && catalogId?.length < 5 ? "Enter valid catalog id" : null
          }
        />
        <div
          className="flex"
          style={{ justifyContent: "end", marginTop: "30px", columnGap: 20 }}
        >
          <Button
            onClick={() => {
              setIsCatalogOpen(false);
              setCatalogId(null);
            }}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            label="Connect"
            disabled={catalogId?.length < 5 || !catalogId}
            onClick={() => {
              createCatalog();
            }}
          >
            Connect
          </Button>
        </div>
      </div>
    );
  }
  function renderSnackbar() {
    return (
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    );
  }
  function renderLoginDialog() {
    return (
      <IntegrationDialog
        isOpen={isOpen}
        title="Facebook Login"
        content={renderForm}
        onCancel={() => {
          setStep(1);
          setIsOpen(false);
        }}
      />
    );
  }

  function renderCatalogDialog() {
    return (
      <IntegrationDialog
        isOpen={isCatalogOpen}
        title="Connect Catalog"
        content={renderCatalogForm}
        onCancel={() => {
          setIsCatalogOpen(false);
        }}
      />
    );
  }
  function fetchData() {
    ServicesService.getWhatsapp("whatsapp")
      .then((response) => {
        setWhatsapp({
          phoneNumberId: response?.getPhoneNumberId(),
          wabaId: response?.getWabaId(),
          accessToken: response?.getAccessToken(),
          storeId: response?.getStoreId(),
          isEmbeddedSignup: response?.getIsEmbeddedSignup(),
          businessNumber: response?.getPhoneNumber(),
          isHistory: response?.getIsHistorySync(),
          isContact: response?.getIsContactSync(),
          chunkData: response?.getChunkData(),
        });
        // setWhatsappId(response?.getId());
      })
      .catch((error) => {
        console.error("Error fetching WhatsApp data:", error);
        if (error.response?.status === 401) {
          setSnackbar({
            open: true,
            message: "Please log in to access WhatsApp features",
            severity: "error",
          });
        }
      });
  }

  function fetchCatalog() {
    ServicesService.getCatalog().then((res) => setCatalogId(res));
  }
  function handleWhatsappChange(value, field) {
    setWhatsapp((prev) => ({
      ...prev,
      [field]: value,
    }));
  }
  async function handleSaveWhatsapp() {
    try {
      const model = new WhatsApp();
      model.setPhoneNumberId(whatsapp.phoneNumberId);
      model.setWabaId(whatsapp.wabaId);
      model.setAccessToken(whatsapp.accessToken);
      model.setStoreId(whatsapp.storeId);
      model.setPhoneNumber(whatsapp.businessNumber);
      model.setIsEmbeddedSignup(0);
      await ServicesService.createWhatsapp(model);
      setWhatsapp(model);
      // setWhatsappId(id);
      setSnackbar({
        open: true,
        message: "Chatbot created successfully!",
        severity: "success",
      });
      setIsProfileOpen(false);
    } catch (error) {
      const message = errorMessage(error);
      if (message) {
        setSnackbar({
          open: true,
          message: `${message}`,
          severity: "error",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Something went wrong",
          severity: "error",
        });
      }
    }
  }
  async function handleSyncHistory(type) {
    try {
      await ServicesService.syncHistory(type);
      fetchData();
    } catch (error) {
      console.log('error', error);
      setSyncDialogOpen(false);
      const message = errorMessage(error);
      if (message) {
        setSnackbar({
          open: true,
          message: `${message}`,
          severity: "error",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Something went wrong",
          severity: "error",
        });
      }
    }
  }
  useEffect(() => {
    MyAccountService.fetch().then((model) => {
      setAccName(model);
    });
    ServicesService.getAppId().then((res) => {
      setAppId(res.appID);
      setConfigId(res.configID);
    });
    fetchData();
    fetchCatalog();
  }, []);
  function handleOpenFacebook() {
    setIsOpen(true);
  }
  function handleOpenCatalog() {
    fetchCatalog();
    setIsCatalogOpen(true);
  }

  async function handleLogout() {
    const domain = API_CONFIG.BASE_URL;
    const url = `${domain}/signout`;
    setIsProfileOpen(false);
    await axios.post(
      url,
      {},
      {
        withCredentials: true,
      },
    );
    window.location.replace("/");
  }
  useEffect(() => {
    if (!appId) return;
    // Load Facebook SDK script if not already loaded
    if (!document.getElementById("facebook-jssdk")) {
      const script = document.createElement("script");
      script.id = "facebook-jssdk";
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v23.0",
      });
      setIsFbReady(true);
    };
    const allowedOrigins = [
      "https://www.facebook.com",
      "https://web.facebook.com",
      "https://business.facebook.com",
    ];

    async function handleMessage(event) {
      if (!allowedOrigins.includes(event.origin)) return;
      try {
        let data;
        console.log("embededEventData", event?.data);

        try {
          data =
            typeof event.data === "string"
              ? JSON.parse(event.data)
              : event.data;
        } catch {
          return;
        }
        if (data.type !== "WA_EMBEDDED_SIGNUP") return;

        if (
          data.event === "FINISH" ||
          data.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING"
        ) {
          const { phone_number_id, waba_id, business_id } = data.data;
          console.log("Phone:", phone_number_id, "WABA:", waba_id);
          pendingSignupRef.current = { phone_number_id, waba_id, business_id };
        }

        if (data.event === "CANCEL") {
          console.warn("User cancelled at step:", data.data.current_step);
        }

        if (data.event === "ERROR") {
          console.error("Embedded signup error:", data.data.error_message);
        }
      } catch (err) {
        console.log("Raw message event:", event.data);
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [appId]);
  const launchWhatsAppSignup = () => {
    setShowCopyDialog(true);
    if (!isFbReady || !window.FB || !window.FB.login) {
      console.error("Facebook SDK is not ready yet.");
      return;
    }
    async function handleAccessTokenExchange(code) {
      try {
        console.log("Token code:", code);
        if (pendingSignupRef.current) {
          const payload = pendingSignupRef.current;
          const model = new WhatsApp();
          model.setPhoneNumberId(payload.phone_number_id);
          model.setWabaId(payload.waba_id);
          model.setBusinessId(payload.business_id);
          model.setIsEmbeddedSignup(1);
          model.setToken(code);
          const res = await ServicesService.createEmbeddedWhatsapp(model);
          console.log("short_token", code);
          console.log("user_token", res);
          setIsOpen(false);
          setStep(1);
          setMoreAnchorEl(null);
          setCopyDialogData({
            phone_number_id: payload.phone_number_id,
            waba_id: payload.waba_id,
          });
          setShowCopyDialog(true);
          setCopiedPhone(false);
          setCopiedWaba(false);
        }
      } catch (error) {
        console.error("Error during token exchange:", error);
      }
    }
    function fbLoginCallback(response) {
      if (response.authResponse) {
        const { code } = response.authResponse;
        console.log("Token code:", code);
        handleAccessTokenExchange(code);
      } else {
        console.log("FB login failed:", response);
      }
    }
    window.FB.login(fbLoginCallback, {
      config_id: configId,
      response_type: "code",
      override_default_response_type: true,
      extras: {
        setup: {},
        featureType: "whatsapp_business_app_onboarding",
        sessionInfoVersion: "3",
      },
    });
  };
  const iswhatsapp =
    whatsapp.phoneNumberId != null || whatsapp.phoneNumberId !== "";
  // Responsive: show first N tabs, rest in More menu
  const MAX_TABS_DESKTOP = 6; // adjust as needed for your layout
  const visibleTabs = !isMobile ? tabs.slice(0, MAX_TABS_DESKTOP) : tabs;
  const overflowTabs = !isMobile ? tabs.slice(MAX_TABS_DESKTOP) : [];

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 4,
        backgroundColor: "#fff",
        color: "#333",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* Left Section */}
        {/* Logo */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            component="img"
            src={Logo}
            alt="WappGrow Logo"
            sx={{
              width: 152,
              height: 52,

              objectFit: "contain",
            }}
          />
        </Box>

        {/* Desktop Navigation */}
        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              minWidth: 0,
              mx: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                justifyContent: "center",
                whiteSpace: "nowrap",
                flex: 1,
                minWidth: 0,
              }}
            >
              {visibleTabs.map((tab) => {
                const isActive = activeTab === tab.id;

                return (
                  <Box
                    key={tab.id + tab.label}
                    onClick={() => onTabChange(tab.id)}
                    sx={{
                      px: 2,
                      py: 1,
                      gap: 1,
                      cursor: "pointer",
                      color: isActive ? "#4A81E6" : "#666",
                      fontWeight: isActive ? 500 : 400,
                      borderRadius: 1,
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={isActive ? tab.activeIcon : tab.inactiveIcon}
                      alt={tab.label}
                      style={{ width: "20px", height: "20px" }}
                    />
                    {tab.label}
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}

        {/* Right Section */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {!isMobile && (
            <Box
              onClick={() => {
                fetchData();
                setIsProfileOpen(true);
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                cursor: "pointer",
                px: 1,
                py: 0.5,
                borderRadius: 2,
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <Avatar
                sx={{
                  width: 46,
                  height: 46,
                  bgcolor: "#1976d2",
                }}
              >
                <PersonIcon sx={{ fontSize: 35, color: "#fff" }} />
              </Avatar>

              <Box>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    fontFamily: `"Poppins", sans-serif`,
                    lineHeight: 1.2,
                  }}
                >
                  {accName?.getFirstName?.()}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: `"Poppins", sans-serif`,
                    color: "#757575",
                  }}
                >
                  {accName?.getEmail?.()}
                </Typography>
              </Box>
            </Box>
          )}
          {/* {overflowTabs.length > 0 && ( */}
          {!isMobile && (
            <Box>
              <IconButton
                onClick={(e) => setMoreAnchorEl(e.currentTarget)}
                sx={{
                  ml: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
                aria-label="more options"
              >
                <MoreVertIcon />
                {/* <Box component="span" sx={{ fontSize: 14 }}>
                      More
                    </Box> */}
              </IconButton>
              <Menu
                sx={{ mt: 4 }}
                anchorEl={moreAnchorEl}
                open={Boolean(moreAnchorEl)}
                onClose={() => setMoreAnchorEl(null)}
              >
                {overflowTabs.map((tab) => (
                  <MenuItem
                    style={{ gap: 12 }}
                    key={tab.id + tab.label}
                    onClick={() => {
                      onTabChange(tab.id);
                      setMoreAnchorEl(null);
                    }}
                    selected={activeTab === tab.id}
                  >
                    {tab.icon} {tab.label}
                  </MenuItem>
                ))}
                <Box sx={{ p: 2 }}>
                  {/* Section Title */}
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      color: "text.primary",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  >
                    Facebook & Catalog
                  </Typography>

                  {/* Facebook Connection */}
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "text.secondary" }}
                    >
                      Connect your Facebook account to enable WhatsApp Business
                      features.
                    </Typography>

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handleOpenFacebook}
                      // disabled={whatsapp.isEmbeddedSignup === 1}
                    >
                      {whatsapp.isEmbeddedSignup === 1
                        ? "Facebook Connected"
                        : "Connect Facebook"}
                    </Button>
                  </Box>

                  {/* Catalog Connection */}
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "text.secondary" }}
                    >
                      Link your product catalog to sync items for messaging and
                      commerce.
                    </Typography>

                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={handleOpenCatalog}
                      disabled={catalogId != null}
                    >
                      {catalogId
                        ? `Catalog Connected '${catalogId}'`
                        : "Connect Catalog"}
                    </Button>
                  </Box>
                  <Box>
                    {whatsapp.isEmbeddedSignup === 1 && (
                      <>
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, color: "text.secondary" }}
                        >
                          Sync your whatsapp business contacts and chat history.
                        </Typography>
                        <Button
                          fullWidth
                          variant="outlined"
                          size="small"
                          onClick={() => setSyncDialogOpen(true)}
                        >
                          Sync History
                        </Button>
                      </>
                    )}
                  </Box>
                </Box>
              </Menu>
            </Box>
          )}
          {/* )} */}

          {/* Mobile Menu Icon */}
          {isMobile && (
            <IconButton onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
          )}
        </Box>
      </Toolbar>
      <Dialog
        open={isProfileOpen}
        onClose={() => {
          setIsProfileOpen(false);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            fontSize: "20px",
            fontWeight: 600,
            color: "#1a1a1a",
          }}
        >
          Whatsapp details
        </DialogTitle>
        <DialogContent sx={{ pt: 5 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 1 }}>
            {(whatsapp.storeId === "stor_74ukjthhc8u64b9jcru3" ||
              whatsapp.storeId === "stor_6hgk8eb16gt66b9g6hjk") && (
              <>
                <TextField
                  label="Phonenumber Id"
                  placeholder={!iswhatsapp ? "Enter Phonenumber id" : null}
                  fullWidth
                  value={whatsapp.phoneNumberId}
                  onChange={(e) =>
                    handleWhatsappChange(e.target.value, "phoneNumberId")
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
                <TextField
                  label="Waba Id"
                  placeholder={!iswhatsapp ? "Enter Waba id" : null}
                  fullWidth
                  value={whatsapp.wabaId}
                  onChange={(e) =>
                    handleWhatsappChange(e.target.value, "wabaId")
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
                <TextField
                  label="Access Token"
                  placeholder={!iswhatsapp ? "Enter AccessToken" : null}
                  fullWidth
                  value={whatsapp.accessToken}
                  onChange={(e) =>
                    handleWhatsappChange(e.target.value, "accessToken")
                  }
                  // InputProps={{
                  //     readOnly: whatsapp.isEmbeddedSignup === 1,
                  // }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      //   ...(whatsapp.isEmbeddedSignup === 1 && {
                      //   pointerEvents: "none",
                      //   userSelect: "none",
                      //   color: "text.disabled"
                      // }),
                    },
                  }}
                />
              </>
            )}
            <TextField
              label="Whatapp Business Number"
              placeholder={!iswhatsapp ? "Enter Business Number" : null}
              fullWidth
              length={15}
              value={whatsapp.businessNumber}
              onChange={(e) =>
                handleWhatsappChange(e.target.value, "businessNumber")
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
            <TextField
              label="Store Id"
              placeholder={!iswhatsapp ? "Enter store Id" : null}
              fullWidth
              value={whatsapp.storeId}
              onChange={(e) => handleWhatsappChange(e.target.value, "storeId")}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 1 }}>
          <Button
            onClick={() => handleLogout()}
            sx={{ borderRadius: 2, color: "#f35050ff" }}
          >
            Logout
          </Button>
          <Button
            onClick={() => setIsProfileOpen(false)}
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveWhatsapp}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              borderRadius: 2,
              px: 3,
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Drawer anchor="right" open={mobileOpen} onClose={toggleDrawer}>
        <Box
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 4,
            width: 260,
            p: 2,
            pt: { xs: "56px", sm: "64px" },
          }}
        >
          {tabs.map((tab) => (
            <Box
              key={tab.id}
              onClick={() => {
                onTabChange(tab.id);
                toggleDrawer();
              }}
              sx={{
                py: 1.5,
                cursor: "pointer",
                fontWeight: activeTab === tab.id ? 600 : 500,
                color: activeTab === tab.id ? "#1976d2" : "#333",
              }}
            >
              {tab.icon} {tab.label}
            </Box>
          ))}

          <Divider sx={{ my: 2 }} />

          <Button
            fullWidth
            variant="contained"
            sx={{ mb: 1 }}
            onClick={() => {
              handleOpenFacebook();
              toggleDrawer();
            }}
          >
            Facebook
          </Button>

          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              handleOpenCatalog();
              toggleDrawer();
            }}
          >
            Connect Catalog
          </Button>
          {whatsapp.isEmbeddedSignup === 1 && (
            <Button
              variant="outlined"
              size="small"
              sx={{ mt: 2, mb: 1 }}
              onClick={() => setSyncDialogOpen(true)}
            >
              Sync History
            </Button>
          )}
        </Box>
      </Drawer>
      {renderSnackbar()}
      {renderLoginDialog()}
      {renderCatalogDialog()}
      {renderCopyDialog()}
      {renderSyncDialog()}
    </AppBar>
  );
};

export default TopNavigation;
